module.exports = __webpack_public_path__ + "static/media/arrow-2.220b6b35.svg";